
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import {
documentTypeAllList

} from "@/common/js/const";


import regexpValid from "@/common/js/regexp.js";
import Box from 'vux/src/components/box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {

directives: {
TransferDom
},
components: {
Group,
Cell,
Datetime,
XInput,
Box,
XHeader,
XButton
},
data() {
return {

invoiceInfo: {
no: "",
code: "",
date: "",
checkCode: "",
documentType: ""
},

validInvoiceCode(val) {
if (regexpValid.invoiceCode(val)) {
return { valid: true, msg: "" };
} else {
return { valid: false, msg: this.$t("10或12位") };
}
},

validInvoiceNo(val) {
if (regexpValid.invoiceNo(val)) {
return { valid: true, msg: "" };
} else {
return { valid: false, msg: this.$t("8位") };
}
}
};
},
created() {},
activated() {
var $self = this;
var no = $self.$route.query.no;
var code = $self.$route.query.code;
var documentType = $self.$route.query.documentType;

$self.invoiceInfo.code = code;
$self.invoiceInfo.no = no;
$self.invoiceInfo.documentType = documentType;

},

/**计算属性 将状态表中的数据 映射出来*/
computed: {},
/**初始化的时候调用  类似于 ready */
mounted() {},
methods: {
...mapActions({
ACTION_setPageLoadingTrue: "common_ac_setPageLoadingTrue"
}),
...mapActions({
ACTION_setPageLoadingFalse: "common_ac_setPageLoadingFalse"
}),
...mapActions({
ACTION_setInvoiceIndexReload: "invoice_ac_setinvoiceIndexReload"
}),

saveJuanPiao() {
var $self = this;
if (
$self.invoiceInfo.documentType == "" ||
$self.$refs.input_invoice_code_2.valid == false ||
$self.$refs.input_invoice_no_2.valid == false ||
$self.$refs.input_invoice_date_2.valid == false
) {
$self.$vux.toast.show({
text: $self.$t("表单验证失败提示"),
type: "text"
});
return false;
}
var vmodel = {
invoiceCode: $self.invoiceInfo.code,
invoiceNo: $self.invoiceInfo.no,
paperDrewDate: $self.invoiceInfo.date.replace(/-/g, ""),
amountWithoutTax: 0,
checkCode: $self.invoiceInfo.checkCode,
documentType: $self.invoiceInfo.documentType
};
$self.ACTION_setPageLoadingTrue();
$self.$webapi.createInvoice2(vmodel).then(res => {
$self.ACTION_setPageLoadingFalse();
if (res.data.status == 1) {


$self.ACTION_setInvoiceIndexReload({
type:'2',
reserve:'',
});



$self.viewStep = 1;
$self.invoiceInfo = {
no: "",
code: "",
date: "",
checkCode: "",
documentType: ""
};
$self.$vux.alert.show({
title: $self.$t("操作成功"),
content: $self.$t("增值税发票上传成功"),
onShow() {},
onHide() {
$self.$router.replace('/invoice/create');
}
});
} else {
$self.$vux.toast.show({
text: res.data.msg,
type: "text"
});
}
});
}
}
};
